var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.severity > 2)?_c('font-awesome-icon',{attrs:{"icon":['fad', 'heartbeat'],"color":_vm.color}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }